"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

const react_1 = __importDefault(require("react"));

const Column_1 = __importDefault(require("../column/Column"));

const Row_1 = __importDefault(require("../row/Row"));

const SizedBox_1 = __importDefault(require("../sized-box/SizedBox"));

const ConstrainedBox_1 = __importDefault(require("../constrained-box/ConstrainedBox"));

const FormField = props => {
  return react_1.default.createElement(Column_1.default, null, (props.title || props.indicator) && react_1.default.createElement(Row_1.default, {
    mainAxisAlignment: "space-between"
  }, react_1.default.createElement("span", null, props.title), react_1.default.createElement("span", null, props.indicator)), react_1.default.createElement(SizedBox_1.default, {
    height: "0.5rem"
  }), props.children, react_1.default.createElement(SizedBox_1.default, {
    height: "0.5rem"
  }), react_1.default.createElement(ConstrainedBox_1.default, {
    minHeight: "1rem"
  }, props.error ? props.error : props.hint));
};

exports.default = FormField;